import { type ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { SearchIcon } from '@treams/treams-icons';
import { Input } from '@treams/treams-ui';
import { Container } from '@treams/treams-ui/common/Container';
import { FlexGap } from '@treams/treams-ui/common/FlexGap';
import { Jumbo } from '@treams/treams-ui/common/Jumbo';
import { tokens } from '@treams/treams-ui/theme/tokens';

import { GenderGapTable } from './GenderGapTable';
import { RewardFunctions } from './RewardFunctions';
import { RewardSummary } from './RewardSummary';
import { useRewardAnalytics } from './useRewardAnalytics';

const Figures = styled(FlexGap)`
	font-variant-numeric: tabular-nums;
`;

export function RewardAnalytics(props: { headerFooter?: ReactNode }) {
	const { t } = useTranslation();
	const { loading, functions, genderGap, summary } = useRewardAnalytics();
	const [query, setQuery] = useState('');

	return (
		<>
			<Jumbo title={t('analytics.overview.title')} footer={props.headerFooter} wide={true} />
			<Container py={4} wide={true} minWidth={0}>
				{loading ? (
					<FlexGap flexDirection="column" gap={tokens.gap.group}>
						<RewardSummary.Skeleton />
						<RewardFunctions.Skeleton />
					</FlexGap>
				) : (
					<Figures flexDirection="column" gap={tokens.gap.section}>
						{summary && <RewardSummary summary={summary} />}
						<Box width={280} maxWidth="100%">
							<Input
								search
								clearable={query.length > 0}
								icon={<SearchIcon />}
								value={query}
								onChange={setQuery}
								placeholder={t('analytics.reward.searchPlaceholder')}
							/>
						</Box>
						<RewardFunctions functions={functions ?? []} query={query} />
						{genderGap && <GenderGapTable genderGap={genderGap} query={query} />}
					</Figures>
				)}
			</Container>
		</>
	);
}
